import { CloudProvider } from "@/gen/api/user"

interface CloudRegionDef {
  displayName: string,
  name: string,
}

export const AzureUSGovRegions = [
  {
    name: "usgovarizona",
    displayName: "US Gov Arizona"
  },
  {
    name: "usgoviowa",
    displayName: "US Gov Iowa"
  },
  {
    name: "usgovtexas",
    displayName: "US Gov Texas"
  },
  {
    name: "usgovvirginia",
    displayName: "US Gov Virginia"
  },
]

export const AzureRegions = [
  { displayName: "Central US", name: "centralus" },
  { displayName: "East US 2", name: "eastus2" },
  { displayName: "East US", name: "eastus" },
  { displayName: "North Central US", name: "northcentralus" },
  { displayName: "South Central US", name: "southcentralus" },
  { displayName: "West Central US", name: "westcentralus" },
  { displayName: "West US 2", name: "westus2" },
  { displayName: "West US", name: "westus" },
]

export const CloudRegionsMap: Partial<Record<CloudProvider, CloudRegionDef[]>> = {
  [CloudProvider.Azure]: AzureRegions,
  [CloudProvider.AzureUSGovernment]: AzureUSGovRegions,
}
